<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "s-button",
  methods: {
    go(e) {
      if (!this.confirm) this.$emit("execute", e);
      else
        this.$confirm(this.confirm, "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        })
          .then(() => {
            this.$emit("execute", e);
          })
          .catch(() => {
            this.$emit("cancel", e);
          });
    }
  },
  props: {
    right: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "primary"
    },
    confirm: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    },

    size: {
      type: String,
      default: null
    }
  }
};
</script>
